import { fetcher, poster, patcher, deleter } from "./axios.js";

// Loop Themes API
export const fetchLoopThemes = async (loopId) => {
    const response = await fetcher(`/loopthemes/?loop_id=${loopId}`);
    return response.data;
};

export const createLoopTheme = async (themeData) => {
    const response = await poster("/loopthemes/", themeData);
    return response.data;
};

export const updateLoopTheme = async (themeId, themeData) => {
    const response = await patcher(`/loopthemes/${themeId}/`, themeData);
    return response.data;
};

export const deleteLoopTheme = async (themeId) => {
    const response = await deleter(`/loopthemes/${themeId}/`);
    return response;
};

// Loop KPIs API
export const fetchLoopKPIs = async (loopId) => {
    const response = await fetcher(`/loopkpis/?loop_id=${loopId}`);
    return response.data;
};

export const createLoopKPI = async (kpiData) => {
    const response = await poster("/loopkpis/", kpiData);
    return response.data;
};

export const updateLoopKPI = async (kpiId, kpiData) => {
    const response = await patcher(`/loopkpis/${kpiId}/`, kpiData);
    return response.data;
};

export const deleteLoopKPI = async (kpiId) => {
    const response = await deleter(`/loopkpis/${kpiId}/`);
    return response;
};

// Loop Goals API
export const fetchLoopGoals = async (loopThemeId) => {
    const response = await fetcher(`/loopgoals/?loop_theme_id=${loopThemeId}`);
    return response.data;
};

export const createLoopGoal = async (goalData) => {
    const response = await poster("/loopgoals/", goalData);
    return response.data;
};

export const updateLoopGoal = async (goalId, goalData) => {
    const response = await patcher(`/loopgoals/${goalId}/`, goalData);
    return response.data;
};

export const deleteLoopGoal = async (goalId) => {
    const response = await deleter(`/loopgoals/${goalId}/`);
    return response;
};

// Loop Layers API
export const fetchLoopLayers = async (loopId) => {
    const response = await fetcher(`/looplayers/?loop_id=${loopId}`);
    return response.data;
};

export const createLoopLayer = async (layerData) => {
    const response = await poster("/looplayers/", layerData);
    return response.data;
};

export const deleteLoopLayer = async (layerId) => {
    const response = await deleter(`/looplayers/${layerId}/`);
    return response;
};

// Loop Segments API
export const fetchLoopSegments = async (loopId) => {
    const response = await fetcher(`/loopsegments/?loop_id=${loopId}`);
    return response.data;
};

export const createLoopSegment = async (segmentData) => {
    const response = await poster("/loopsegments/", segmentData);
    return response.data;
};

export const updateLoopSegment = async (segmentId, segmentData) => {
    const response = await patcher(`/loopsegments/${segmentId}/`, segmentData);
    return response.data;
};

export const deleteLoopSegment = async (segmentId) => {
    const response = await deleter(`/loopsegments/${segmentId}/`);
    return response;
};

// Enhanced Loop API (for getting all loop data at once)
export const fetchEnhancedLoop = async (loopId) => {
    const response = await fetcher(`/enhancedloops/${loopId}/`);
    return response.data;
};

// Helper function to load all loop data
export const loadLoopData = async (loopId) => {
    try {
        const [
            themesResponse,
            kpisResponse,
            layersResponse,
            segmentsResponse
        ] = await Promise.all([
            fetchLoopThemes(loopId),
            fetchLoopKPIs(loopId),
            fetchLoopLayers(loopId),
            fetchLoopSegments(loopId)
        ]);

        // Fetch goals for each theme
        const goalsPromises = themesResponse.map(theme => 
            fetchLoopGoals(theme.id)
        );
        const goalsResponses = await Promise.all(goalsPromises);
        const allGoals = goalsResponses.flat();

        return {
            themes: themesResponse,
            kpis: kpisResponse,
            goals: allGoals,
            layers: layersResponse,
            segments: segmentsResponse
        };
    } catch (error) {
        console.error("Error loading loop data:", error);
        throw error;
    }
}; 